<script setup lang="ts">
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useDialog } from '@/composables/useDialog'

const { state, closeWith } = useDialog()
</script>

<template>
  <AlertDialog :open="state.open">
    <AlertDialogContent class="pointer-events-auto sm:max-w-sm">
      <AlertDialogHeader>
        <AlertDialogTitle>{{ state.title }}</AlertDialogTitle>
        <AlertDialogDescription v-if="state.description">
          {{ state.description }}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter class="gap-2">
        <AlertDialogCancel @click="closeWith(false)">{{ state.cancelLabel }}</AlertDialogCancel>
        <AlertDialogAction
          :class="state.variant === 'destructive' ? 'bg-destructive text-primary-foreground hover:bg-destructive/90' : ''"
          @click="closeWith(true)"
        >
          {{ state.confirmLabel }}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
